import { useCallback, useEffect, useState } from "react";

import { getTariffs } from "services/tariffs/rest";
import { TariffDto } from "services/tariffs/restModels";

export interface UseTariffsResult {
    tariffs: TariffDto[];
    loading: boolean;
    error: boolean;
    refetch: () => void;
}

export const useTariffs = (): UseTariffsResult => {
    const [tariffs, setTariffs] = useState<TariffDto[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<boolean>(false);
    const [reloadKey, setReloadKey] = useState<number>(0);

    const refetch = useCallback(() => setReloadKey((key) => key + 1), []);

    useEffect(() => {
        // ignore-флаг: ответ после размонтирования не трогает стейт.
        let ignore = false;

        setLoading(true);
        setError(false);

        getTariffs()
            .then((result) => {
                if (ignore) return;
                if (result) {
                    setTariffs(result);
                } else {
                    setError(true);
                    setTariffs([]);
                }
            })
            .catch(() => {
                if (ignore) return;
                setError(true);
                setTariffs([]);
            })
            .finally(() => {
                if (ignore) return;
                setLoading(false);
            });

        return () => {
            ignore = true;
        };
    }, [reloadKey]);

    return { tariffs, loading, error, refetch };
};
